import { createContext, useCallback, useState } from "react";

type LoadingModalContext = {
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
  activeButtonId: string;
  setActiveButtonId: (id: string) => void;
};

const defaultContext: LoadingModalContext = {
  isLoading: false,
  setIsLoading: () => { /**intentionally empty */},
  activeButtonId: "",
  setActiveButtonId: () => { /**intentionally empty */},
};

export const LoadingModalContext =
  createContext<LoadingModalContext>(defaultContext);

// custom Hook
export const useLoadingModal = (): LoadingModalContext => {
  const [isLoading, setLoading] = useState(false);
  const [activeButtonId, setActiveButtonIdState] = useState("");

  const setActiveButtonId = useCallback((id: string): void => {
    setActiveButtonIdState(id);
  }, []);

  const setIsLoading = useCallback((current: boolean): void => {
    setLoading(current);
    if (!current) {
      setActiveButtonIdState("");
    }
  }, []);

  return {
    isLoading,
    setIsLoading,
    activeButtonId,
    setActiveButtonId,
  };
};
